import './web-bootstrap'

import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import Locales from './vue-i18n-locales.generated.js'
import Api from '~/api/web'

import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import CountdownTime from './web-components/CountdownTime.vue'
import CountdownTimeV2 from './web-components/CountdownTimeV2.vue'
import LeadComponent from './web-components/LeadComponent.vue'
import Quiz from './web-components/Quiz.vue'
import Delete from './components/Delete.vue'
import CancelSubscription from './components/CancelSubscription.vue'
import Pending from './components/TransactionPending.vue'
import Topic from '~/web-components/community/Topic.vue'
import CommunityGalleryPreview from '~/web-components/community/GalleryPreview.vue'
import CommunityGallery from '~/web-components/community/Gallery.vue'
// import CommunityNotifications from '~/app2/components/community/CommunityNotifications.vue'
import Post from '~/web-components/community/PostShow.vue'
import PostCreate from '~/web-components/community/PostCreate.vue'
import CardUpdate from '~/web-components/CardUpdate.vue'
import CardUpdatePayu from '~/web-components/CardUpdatePayu.vue'

import CheckoutSubscription from './shortcodes/CheckoutSubscription.vue'
import CheckoutSingle from './shortcodes/CheckoutSingle.vue'
import VideoEmbed from './shortcodes/VideoEmbed.vue'
import AccessManager from './web-components/AccessManager.vue'
import Slider from './shortcodes/Slider.vue'
import GalleryLightbox from './shortcodes/GalleryLightbox.vue'
import SurveyComponent from '~/web-components/Survey.vue'
import BeforeAfter from '~/web-components/BeforeAfter.vue'
import Search from '~/web-components/Search.vue'
import Reviews from '~/web-components/Reviews.vue'

window.Vue = Vue

Vue.component('reviews-component', Reviews)
Vue.component('search-component', Search)
Vue.component('lead-component', LeadComponent)
Vue.component('card-update', CardUpdate)
Vue.component('card-update-payu', CardUpdatePayu)
Vue.component('pending', Pending)
Vue.component('countdown-time', CountdownTime)
Vue.component('countdown-time-v2', CountdownTimeV2)
Vue.component('quiz', Quiz)
Vue.component('cancel-subscription', CancelSubscription)
Vue.component('delete', Delete)
Vue.component('access-manager', AccessManager)
Vue.component('community-topic', Topic)
Vue.component('community-post', Post)
Vue.component('community-post-create', PostCreate)
// Vue.component('community-notifications', CommunityNotifications)

Vue.component('checkout-subscription', CheckoutSubscription)
Vue.component('checkout-single', CheckoutSingle)
Vue.component('video-embed', VideoEmbed)
Vue.component('slider', Slider)
Vue.component('gallery-lightbox', GalleryLightbox)
Vue.component('community-gallery-preview', CommunityGalleryPreview)
Vue.component('community-gallery', CommunityGallery)
Vue.component('survey-component', SurveyComponent)
Vue.component('before-after', BeforeAfter)

import state from './store/web'

const store = new Vuex.Store(state)

Vue.use(vuexI18n.plugin, store)
Vue.use(Api)

Vue.i18n.add('en', Locales.en)
Vue.i18n.add('pl', Locales.pl)

const lang = document.documentElement.lang.substr(0, 2)

Vue.i18n.set(lang)

Sentry.init({
  environment: process.env.MIX_ENV || 'local',
  dsn: 'https://4d485e6275e7459d8b2c1d360612d32f@sentry.io/2469622',
  tracesSampleRate: 0.25,
  beforeSend(event, hint) {
    const error = hint.originalException
    if (
      error &&
      error.message &&
      (error.message.match(/Request failed with status code 419/i) || error.message.match(/Network Error/i))
    ) {
      return null
    }

    return event
  },
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    'Script error.',
    // Avast extension error
    '_avast_submit',
    /eapps\.Platform throws: "Widget "[\w-]+" can`t be initialized because APP_VIEWS_LIMIT_REACHED/,
    'Non-Error exception captured',
    'Non-Error promise rejection captured',
    'Failed to fetch',
  ],
  denyUrls: [
    /cdn-cgi\/apps\/body\/.*\.js/i,
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    /www\.googletagmanager\.com\/gtag\/js/i,
    /www\.googletagmanager\.com\/gtm\/js/i,
  ],
  allowUrls: [
    /https?:\/\/.*\/js\/checkout\.js/i,
    /https?:\/\/.*\/js\/web-app\.js/i,
    /https?:\/\/.*\/js\/exam-app\.js/i,
    /https?:\/\/.*\/js\/player-app\.js/i,
    /https?:\/\/.*\/js\/manifest\.js/i,
    /https?:\/\/.*\/js\/vendor\.js/i,
    /https?:\/\/.*\/js\/app2\.js/i,
    /https?:\/\/.*\/js\/quill-s\.js/i,
  ],
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true,
      logErrors: true,
    }),
    new Integrations.CaptureConsole({
      levels: ['error'],
    }),
  ],
})

const app = new Vue({
  el: '#app',
  store,
})
